//# sourceMappingURL=user_id.mjs.map
/// <reference types="./user_id.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";

class UserId extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

/**
 * Wrap a string read from a column that holds a local user id. Every call is
 * a point where the type system stops checking and someone has to be right —
 * which is why decoders and queries should be the only ones calling it.
 * 
 * @ignore
 */
export function from_string(value) {
  return new UserId(value);
}

export function to_string(id) {
  let value = id[0];
  return value;
}

/**
 * Decode a local user id from a stored row or from a payload one of our own
 * services produced. The preferred way in: it keeps `from_string` — which
 * promotes any string at all — off the call sites that only ever decode.
 */
export function decoder() {
  return $decode.map($decode.string, from_string);
}

/**
 * Encode a local user id. Paired with `decoder` so a record's codec never has
 * to reach for `to_string` and accidentally treat it as free text.
 */
export function encode(id) {
  return $json.string(to_string(id));
}
